import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Race20ResultBody from '../../../casinoComponents/refResultModal/Race20ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

const ICONS = `${import.meta.env.BASE_URL}img/cardIcons`;

// win "1"=Spade "2"=Heart "3"=Club "4"=Diamond (reference: resulta / resultb / resulttie classes)
const SUIT_ICON = { '1': 'spade', '2': 'heart', '3': 'club', '4': 'diamond' };
const resultClass = (win) =>
  win === '1' ? 'resulta' : win === '2' ? 'resultb' : win === '0' ? 'resulttie' : '';

/**
 * Race 20 "Last Result" items (rendered inside CasinoLastResult's .casino-video-last-results) —
 * reference markup: span[.resulta|.resultb|.resulttie] > img(suit icon). Click shows the full-page
 * loader overlay while the round detail loads, then the reference result modal.
 */
const ResultRace20 = ({ data = [], gameType = 'race20' }) => {
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [gameType]);

  const handleResultClick = async (resultItem) => {
    const mid = resultItem?.mid;
    if (!mid) return;
    setDetailResult(null);
    setLoading(true);
    try {
      const response = await getDetailResults(gameType, mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) setDetailResult(t1);
    } catch (error) {
      console.error('Error fetching detail results:', error);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res) => ({ win: res?.win ?? res, mid: res?.mid ?? null }));

  return (
    <>
      {allResults.map((resultItem, index) => {
        const win = String(resultItem?.win ?? '');
        const icon = SUIT_ICON[win];
        return (
          <span
            key={index}
            className={resultClass(win)}
            onClick={() => handleResultClick(resultItem)}
          >
            {icon && <img src={`${ICONS}/${icon}.png`} alt="" />}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || 'Race 20'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Race20ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultRace20;
